import { useQuery } from '@tanstack/react-query';
import { listServices } from '../api/endpoints/services';
import { ErrorBanner } from './ErrorBanner';

export function StaffServices({ value, onChange, disabled = false }: {
  value: string[] | undefined;
  onChange(value: string[] | undefined): void;
  disabled?: boolean;
}) {
  const query = useQuery({ queryKey: ['business-services', 'staff-assignment'], queryFn: () => listServices(true) });
  const all = value === undefined;
  return <fieldset className="span-2" disabled={disabled}>
    <legend className="section-label">Servicios que atiende</legend>
    <div className="form-grid">
    <label className="action-pair" style={{ justifyContent: 'flex-start' }}><input type="checkbox" checked={all} onChange={event => onChange(event.target.checked ? undefined : [])} />Todos los servicios</label>
    {query.isLoading ? <p className="row-sub">Cargando servicios…</p> : null}
    {query.isError ? <><ErrorBanner message="No pudimos cargar los servicios. Tus selecciones se conservan." /><button type="button" className="btn small ghost" onClick={() => void query.refetch()}>Reintentar</button></> : null}
    {query.data?.data.map(service => <label className="action-pair" style={{ justifyContent: 'flex-start' }} key={service.id}>
      <input type="checkbox" aria-label={service.name} checked={all || value.includes(service.id)} disabled={all || (!service.isActive && !value.includes(service.id))}
        onChange={event => onChange(event.target.checked ? [...(value ?? []), service.id] : value?.filter(id => id !== service.id))} />
      {service.name}{service.isActive ? '' : ' (inactivo)'}
    </label>)}
    {query.data?.data.length === 0 ? <p className="row-sub">Agrega servicios para asignarlos a una persona.</p> : null}
    {!all && value.length === 0 ? <p role="alert" className="row-sub">Elige al menos un servicio.</p> : null}
    </div>
  </fieldset>;
}
